import type { DefaultError, UseMutationOptions } from "@tanstack/react-query";

/**
 * Creates a type-safe mutation definition with automatic type inference
 *
 * @param mutationFn - The mutation function that accepts variables and returns a Promise
 * @param options - Optional mutation options
 * @returns A mutation definition object compatible with React Query
 */

export function mutationOptions<
  TData = unknown,
  TError = DefaultError,
  TVariables = void,
  TContext = unknown,
>(
  options: UseMutationOptions<TData, TError, TVariables, TContext>,
): UseMutationOptions<TData, TError, TVariables, TContext> {
  return options;
}
